import React from 'react'
import PropTypes from 'prop-types'
import './team7.css'

const Team7 = (props) => {
  const teamMembers = [
    { name: 'Patricia Scotland KC', job: 'Secretary General', src: props.member1Src, wikipedia: 'https://en.wikipedia.org/wiki/Patricia_Scotland' },
    { name: 'Dr. Arjoon Suddhoo', job: 'Deputy Secretary General', src: props.member1Src1, linkedin: 'https://www.linkedin.com/in/dr-arjoon-suddhoo-6820a128/' },
    { name: 'Suresh Yadav', job: 'Senior Director', src: props.member1Src11, linkedin: 'https://www.linkedin.com/in/sureshyadavirs/' },
    { name: 'Dr. Radika Kumar', job: 'Adviser AI', src: props.member2Src, linkedin: 'https://www.linkedin.com/in/radika-kumar-989b3944/' },
    { name: 'Osmal Wood', job: 'Adviser Digital Innovation', src: props.member3Src, linkedin: 'https://www.linkedin.com/in/w-b815aa152/' },
    { name: 'Raj Nair', job: 'Adviser, Governance', src: props.member6Src, linkedin: 'https://www.linkedin.com/in/rajivnair2/' },
    { name: 'Arlene Bussette', job: 'Adviser & Head, ODSG', src: props.member5Src1, linkedin: 'https://www.linkedin.com/in/arlene-bussette/' },
    { name: 'Thomas Evans', job: 'AI Researcher', src: props.member5Src, linkedin: 'https://www.linkedin.com/in/thomas-evans-a80759258/' },
    { name: 'Naman Tapasvi', job: 'AI Researcher', src: props.member1Src2, linkedin: 'https://www.linkedin.com/in/naman-tapasvi/' },
    { name: 'Satyam Sharma', job: 'AI Researcher', src: props.member1Src3, linkedin: 'https://www.linkedin.com/in/satyamsharma96/' },
  ];

  return (
    <div className={`team7-team8 thq-section-padding ${props.rootClassName}`}>
      <div className="team7-max-width thq-section-max-width">
        <div className="team7-section-title">
          <h2 className="thq-heading-2">{props.heading1 ?? "Meet Our Team"}</h2>
        </div>
        <div className="team7-content11">
          {teamMembers.map((member, index) => (
            <div key={index} className={`team7-card${index + 10}`}>
              <img alt={`Portrait of ${member.name}`} src={member.src} className={`team7-placeholder-image${index + 10} thq-img-ratio-1-1 thq-img-round`} />
              <div className={`team7-content${index + 12}`}>
                <div className={`team7-title${index + 10}`}>
                  <span className="thq-body-small">{member.name}</span>
                  <span className="thq-body-small">{member.job}</span>
                </div>
              </div>
              <div className={`team7-social-icons${index + 10}`}>
                {member.wikipedia ? (
                  <a href={member.wikipedia} target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 640 512" className="thq-icon-small wikipedia-icon">
                      <path d="M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"></path>
                    </svg>
                  </a>
                ) : (
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                    <svg viewBox="0 0 877.7142857142857 1024" className="thq-icon-small linkedin-icon">
                      <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                    </svg>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

Team7.defaultProps = {
  heading1: undefined,
  content2: undefined,
  member1Src: '/team/picture%2011-1400w.png',
  member1Src1: '/team/picture%202-1400w.png',
  member1Src11: '/team/picture%203-1400w.png',
  member2Src: '/team/picture%204-1400w.jpg',
  member3Src: '/team/picture%205-1400w.png',
  member6Src: '/team/picture%206-1400w.png',
  member5Src1: '/team/picture%207-1400w.png',
  member5Src: '/team/picture%208-1400w.jpg',
  member1Src2: '/team/picture%209-1400w.jpg',
  member1Src3: '/team/picture%2010-1400w.jpg',
  rootClassName: '',
}

Team7.propTypes = {
  heading1: PropTypes.element,
  content2: PropTypes.element,
  member1Src: PropTypes.string,
  member1Src1: PropTypes.string,
  member1Src11: PropTypes.string,
  member2Src: PropTypes.string,
  member3Src: PropTypes.string,
  member6Src: PropTypes.string,
  member5Src1: PropTypes.string,
  member5Src: PropTypes.string,
  member1Src2: PropTypes.string,
  member1Src3: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Team7